import { AVATAR_PLACEHOLDER_STYLE, avatarInitials } from "@/lib/avatar";

export interface PersonInfo {
  name: string;
  avatarContent?: string | null;
  avatarMime?: string | null;
}

const SIZES = {
  sm: "h-7 w-7 text-[10px]",
  md: "h-9 w-9 text-xs",
  lg: "h-10 w-10 text-sm",
} as const;

export function Avatar({
  person,
  size = "md",
  online,
  onlineLabel,
}: {
  person: PersonInfo;
  size?: keyof typeof SIZES;
  // Show a green presence dot when truthy. Undefined/false renders no
  // dot (we don't distinguish "offline" from "unknown" in the UI).
  online?: boolean;
  onlineLabel?: string;
}) {
  const dim = SIZES[size];
  let inner;
  if (person.avatarContent && person.avatarMime) {
    inner = (
      <img
        src={`data:${person.avatarMime};base64,${person.avatarContent}`}
        alt=""
        className={`${dim} rounded-full object-cover`}
      />
    );
  } else {
    inner = (
      <div
        className={`${dim} flex items-center justify-center rounded-full font-serif`}
        style={AVATAR_PLACEHOLDER_STYLE}
      >
        {avatarInitials(person.name)}
      </div>
    );
  }

  if (!online) return <div className="flex-shrink-0">{inner}</div>;
  return (
    <div className="relative flex-shrink-0">
      {inner}
      <span
        className="absolute -bottom-0.5 -right-0.5 block h-2.5 w-2.5 rounded-full bg-green-500 ring-2 ring-white"
        role="img"
        aria-label={onlineLabel}
        title={onlineLabel}
      />
    </div>
  );
}
